export default __webpack_public_path__ + "locales/tr/Article.json?hash=e2abfffe224f95241a43a5ede0a09c71";